/* Stockwave Combined Listings — storefront behaviour
 *
 * Product page: options are plain links to the sibling product (each colour is
 * still its own product, so the URL moves — same as the demo). We just prefetch
 * on hover and, for multi-option listings, keep hrefs in sync with the current
 * selection.
 *
 * Collection / search cards: clicking a swatch swaps the card's image, price,
 * link and sold-out badge in place, without leaving the grid.
 *
 * Card selectors default to Dawn-family themes. Override for your theme with:
 *   window.SW_LISTING_CARD = { card: '.card-wrapper', image: '.card__media img',
 *                              link: 'a.full-unstyled-link', price: '.price-item--regular',
 *                              compare: '.price-item--sale', badge: '.badge' };
 */
(function () {
  'use strict';
  var CFG = Object.assign({
    card: '.card-wrapper, .product-card, .grid__item, li',
    image: '.card__media img, .card__inner img, .product-card__image img, img',
    link: 'a.full-unstyled-link, a.card__heading-link, a[href*="/products/"]',
    price: '.price-item--regular, .price__regular .price-item, .price, .product-card__price',
    compare: '.price-item--sale, .price__sale .price-item--regular',
    badge: '.badge, .card__badge .badge, .product-card__badge',
    soldOutText: 'Sold out'
  }, window.SW_LISTING_CARD || {});

  var moneyFormat = (window.Shopify && Shopify.money_format) || '${{amount}}';
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var s = moneyFormat.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                       .replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/, function (_, c) { return c ? v.replace('.', ',') : v; });
    return s.replace(/<[^>]+>/g, '');
  }

  function members(root) {
    try { return JSON.parse(root.querySelector('[data-sw-members]').textContent); } catch (e) { return []; }
  }

  // --- product page: keep multi-option hrefs in sync -------------------------
  function initProduct(root) {
    var opts = JSON.parse(root.getAttribute('data-sw-options') || '[]');
    if (opts.length < 2) {
      root.addEventListener('mouseover', function (e) {
        var a = e.target.closest('a.sw-opt'); if (a && !a._pf) { a._pf = 1; prefetch(a.href); }
      });
      return;
    }
    var ms = members(root), cur = ms.filter(function (m) { return m.pid === root.getAttribute('data-sw-current'); })[0];
    if (!cur) return;
    var sel = Object.assign({}, cur.values);
    root.querySelectorAll('.sw-row').forEach(function (row) {
      var opt = row.getAttribute('data-sw-option');
      row.querySelectorAll('a.sw-opt').forEach(function (a) {
        var want = Object.assign({}, sel); want[opt] = a.getAttribute('data-sw-value');
        var exact = ms.filter(function (m) { return opts.every(function (o) { return m.values[o] === want[o]; }); })[0]
                 || ms.filter(function (m) { return m.values[opt] === want[opt]; })[0];
        if (exact) { a.href = '/products/' + exact.handle; a.setAttribute('data-sw-pid', exact.pid); }
      });
    });
  }

  function prefetch(url) {
    var l = document.createElement('link'); l.rel = 'prefetch'; l.href = url; document.head.appendChild(l);
  }

  // --- collection cards: swap in place ---------------------------------------
  function initCard(root) {
    var ms = members(root), card = root.closest(CFG.card) || root.parentElement;
    var showSold = root.getAttribute('data-sw-show-soldout') === 'true';

    function pick(pid, a) {
      var m = ms.filter(function (x) { return x.pid === pid; })[0]; if (!m) return;
      var url = '/products/' + m.handle;
      var img = card.querySelector(CFG.image);
      var src = m.image ? (root.getAttribute('data-sw-img-base') || '') + m.image : '';   // pictures are stored without the shared CDN folder
      if (img && src) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src; if (m.title) img.alt = m.title; }
      card.querySelectorAll(CFG.link).forEach(function (l) { if (/\/products\//.test(l.getAttribute('href') || '')) l.setAttribute('href', url); });
      var heading = card.querySelector(CFG.link);
      if (heading && heading.textContent.trim() && m.title) heading.textContent = m.title;   // big listings leave titles out
      var price = card.querySelector(CFG.price); if (price && m.price != null) price.textContent = money(m.price);
      var cmp = card.querySelector(CFG.compare); if (cmp) cmp.textContent = m.compareAt ? money(m.compareAt) : '';
      var badge = card.querySelector(CFG.badge);
      if (badge && showSold) { badge.textContent = m.available ? '' : CFG.soldOutText; badge.style.display = m.available ? 'none' : ''; }
      root.setAttribute('data-sw-current', pid);
      root.querySelectorAll('.sw-opt').forEach(function (o) { var on = o === a; o.classList.toggle('is-selected', on); o.setAttribute('aria-checked', on); });
      var sel = root.querySelector('[data-sw-select]'); if (sel) sel.value = url;
    }

    root.addEventListener('click', function (e) {
      var a = e.target.closest('a.sw-opt'); if (!a) return;
      e.preventDefault(); e.stopPropagation();
      pick(a.getAttribute('data-sw-pid'), a);
    });
    root.addEventListener('change', function (e) {
      var s = e.target.closest('[data-sw-select]'); if (!s) return;
      e.stopPropagation(); pick(s.options[s.selectedIndex].getAttribute('data-sw-pid'), null);
    });
  }

  // --- dropdown on product page navigates --------------------------------------
  document.addEventListener('change', function (e) {
    var s = e.target.closest('.sw-surface-product [data-sw-select]'); if (s) window.location.href = s.value;
  });

  function init(scope) {
    (scope || document).querySelectorAll('.sw-listing:not([data-sw-ready])').forEach(function (root) {
      root.setAttribute('data-sw-ready', '1');
      if (root.classList.contains('sw-surface-card')) initCard(root); else initProduct(root);
    });
  }
  init();
  // themes that re-render grids via AJAX (filters, infinite scroll)
  new MutationObserver(function () { init(); }).observe(document.body, { childList: true, subtree: true });
})();
